import { ChangeEvent, Key } from "react"
import { ActionMeta, GroupBase, InputActionMeta, MenuPlacement, MultiValue, SingleValue } from "react-select"
import { user_mstr_modal } from "../ReduxTool/Slice/Auth/types"
import { moduleInverterTy } from "../ReduxTool/Slice/Consumer/types"
import globalLayers from "./CustomerMaps/Maps/GlobaLMap"
import Collection from "@arcgis/core/core/Collection"
import Graphic from "@arcgis/core/Graphic"
import { Polygon } from "@arcgis/core/geometry"
export const USER_TYPE_CONSUMER = 'consumer'
export const USER_TYPE_PARTNER = 'partner'
export const OTP_COUNTER = 60;
export const OTP_COUNT = 3
export type INSTALLATION_MODE = "pvNXT Mode" | "Self Mode";
export const PVNXT_MODE = "pvNxt";
export const SELF_MODE = "Self Mode";
export const INSTALLATION_MODE_CONTENT: Record<INSTALLATION_MODE, {
  title: string;
  tagline: string;
  benefitsHeading: string;
  benefits: string[];
  footer: string;
}> = {
  "pvNXT Mode": {
    title: `${PVNXT_MODE} Full Service`,
    tagline: "Hassle-free installation handled end-to-end.",
    benefitsHeading: `All the benefits of ${PVNXT_MODE} service, plus:`,
    benefits: [
      "Detailed 3D roof and shadow analysis",
      "Complete design, approvals, and installation",
      `Best-price installer assigned by ${PVNXT_MODE}`,
      "End-to-end support until system is running",
    ],
    footer: "You can review the full agreement before payment.",
  },
  "Self Mode": {
    title: "Self Mode",
    tagline: "Talk to EPC directly and handle the process yourself.",
    benefitsHeading: "What you get:",
    benefits: [
      "Your request is shared with subscribed installers",
      "Installers contact you with proposals",
      "You compare, choose, and proceed directly",
      "Self Mode can be changed until agreement signing",
    ],
    footer: "Execution and payments will be handled outside the platform.",
  },
};

// Anything that isn't "Self Mode" falls back to pvNxt (covers null and the "pvNxt Mode" casing used in CustomerDashBoard.tsx:92)
export const getInstallationModeContent = (mode?: string | null) =>
  INSTALLATION_MODE_CONTENT[mode === SELF_MODE ? "Self Mode" : "pvNXT Mode"];

export interface IUpdateEvent {
  graphics: any
  state: string
  aborted: boolean
  tool: string
  toolEventInfo: ToolEventInfo
  type: string
}

export interface ToolEventInfo {
  dx: number
  dy: number
  mover: any
  type: string
}
export const FORMTOASTERRID = "allFieldsRequired";


// export const MINUSEABLEAREA = 100;
// export const MAXUSEABLEAREA = 10000;
export const MINUSEABLEAREA = 30;
export const MAXUSEABLEAREA = 100000;
export const parentBuildingIndex = 'parentBuildingIndex'
export const defaultmoduleArea = 3;
export const defaultmoduleWidth = 1.134;
export const defaultmoduleLength = 2.274;
export const defaultmodulePower = 545;
export const voltagepermodule = 500;
export const coverageFactor = 0.8;
// Free projects per account; beyond this each project needs a purchased credit. Same in every environment
// so the paid flow can be tested locally (raise REACT_APP_PROJECT_LIMIT in .env.development.local if needed)
export const projectCreateLimit = parseFloat(process.env.REACT_APP_PROJECT_LIMIT || '2');
// Most extra projects (ProjectCreation credits) a user can buy on top of the free ones
export const maxPurchasedProjects = 5;
// Package bought (one-time, per project) to unlock 3D Roof Analysis; price comes from the backend
export const THREE_D_ANALYSIS_PACKAGE_ID = "54a83e5f-2be7-4e85-a2d1-df05a9acfa51";
// Package bought (one-time, per project) for the proposal booking payment. On test it is "Free" at a fixed 1 INR:
// the backend must price it per project (the UI shows the project's downpayment_percent of projectcost, default 10%) before go-live
export const SUPPORT_EMAIL = "support@terranxt.com";
export const PROPOSAL_PAYMENT_PACKAGE_ID = "8085c808-506e-4cfc-b19f-0e2058efb84e";
// Feature bought as usage credits (one per extra project) once projectCreateLimit is reached
export const PROJECT_CREATION_FEATURE = "ProjectCreation";
export const LocationMarker = 'location-marker'

export const GSTPERCENTAGE = 9;

export interface APIResponse<T> {
  code: string,
  responseData: T,
  message?: string
}
export interface AgGridResponseType<T> {
  page: number
  per_page: number
  total: number
  total_pages: number
  data: T
}
export type TSignWithOtp = {
  email: string,
  toastId: React.MutableRefObject<any>,
  setShow: (value: React.SetStateAction<boolean>) => void
  show: boolean
}
export type sign = {
  email: string, mobile: string, fname: string, lname: string, isMobileValid: boolean
}

export const elevationIndex = 'elevationindex'
export const Azimuth = 'azimuth'
export const TiltAngle = 'TiltAngle'
export const ElevatedSideHeight = 'ElevatedSideHeight'
export const zIndex = 'zIndex'
export const attributeheight = 'height'
export const attributeElevation = 'elevation'
export const elevatedSideLength = 'elevatedSideLength'
export const attributeRings = 'rings'
export const Panels = 'panels'
export const rooftiltangle = 'rooftiltangle'
export const elevationDirection = 'elevationDirection'
export const originalGeometry = 'originalGeometry'
export const isInvalidGeom = 'isInvalidGeom'

//RoofAnalysis Container
export type TDrawerContainer = {
  title: string;
  Component: () => JSX.Element;
  btnTitle: string;
  headerName: string;
}
//Input Props Type
export type TinputType = "text" | "number" | "date" | "checkbox" | "password" | "email" | "file"

export interface IInputProps {
  id?: string,
  labelname?: string,
  name: string,
  value: string | number,
  placeholder?: string
  type: TinputType
  onChange: (e: ChangeEvent<HTMLInputElement>) => void,
  star?: boolean,
  autoFocus?: boolean,
  icon?: JSX.Element,
  errors?: boolean,
  helpertext?: string
};
export type NewinputType = "text" | "number" | "date" | "checkbox" | "password" | "email"
export interface NewInputProps {
  id?: string,
  labelname?: string,
  name: string,
  value: string | number,
  placeholder?: string
  type: NewinputType
  onChange: (e: ChangeEvent<HTMLInputElement>) => void,
  star?: boolean,
  icon?: JSX.Element,
  disabled?: boolean
  maxLength?: number
  content?: string
  hideIcon?: boolean
  max?: string,
  min?: string,
  handlefocus?: (e: any) => void
  onBlur?: (e: any) => void
  autoFocus?: boolean
  onKeyPress?: (e: any) => void
  onKeyUp?: (e: any) => void
  isLoging?: boolean
  title?: string
  tooltipInfo?: string,
  tooltipPositon?: 'right' | 'left' | 'buttom' | 'top',
  submitBtnTxt?: string,
  errors?: boolean,
  helpertext?: string,
  suftext?: string
}
export interface InputPropsTy {
  id?: string,
  label?: string,
  name: string,
  value: string | number,
  placeholder?: string
  type: NewinputType
  onChange: (e: ChangeEvent<HTMLInputElement>) => void,
  required?: boolean,
  icon?: JSX.Element,
  disabled?: boolean
  maxLength?: number
  content?: string
  hideIcon?: boolean
  max?: string,
  min?: string,
  classNames?: string
}
export type selectOptionType = {
  label: string,
  value: string,
}

export type RoofTypeKey = | "rccflat" | "metalsheet" | "tileroof" | "other";

export const RoofTypeTy: Record<RoofTypeKey, string> = {
  rccflat: "RCC Flat",
  metalsheet: "Metal Sheet",
  tileroof: "Tile Roof",
  other: "Other"
};

export type RoofType = | { label: "RCC Flat"; value: "RCC Flat" } | { label: "Metal Sheet"; value: "Metal Sheet" } | { label: "Hybrid"; value: "Hybrid" };
export type GridType = "On Grid" | "Off grid" | "Hybrid";
export type GridTypeOption = | { label: "On Grid"; value: "On Grid" } | { label: "Off Grid"; value: "Off grid" } | { label: "Hybrid"; value: "Hybrid" };
export type tooltipSideType = "RSB" | "LSB";

export interface reactSelectType {
  id?: string,
  name: string,
  placeholder?: string,
  labelname?: string,
  options: any,
  onChange: any,
  value: string | string[] | any,
  isMulti?: boolean | undefined,
  closeMenuOnSelect?: boolean | undefined,
  isUpload?: boolean | undefined,
  icon?: any,
  isRequired?: boolean,
  infoDetails?: string
  filterOptions?: ({ label, value }: { label: any; value: any; }, string: any) => boolean
  disabled?: boolean
  error?: string | null
  pageSize?: number
  isSearchable?: boolean
  handleInputChange?: (newValue: string, name: string, actionMeta: InputActionMeta) => void;
  isLoading?: boolean;
  key?: Key | null | undefined;
  onFoucs?: React.FocusEventHandler<HTMLInputElement> | undefined;
  isrequired?: boolean;
  menuPlacement?: MenuPlacement | undefined;
  noOptionsMessage?: string
  smpadding?: boolean
  helperText?: string;
  tooltipContent?: string | JSX.Element
  onIconBtnClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  istooltipContent?: boolean
  tooltipSide?: tooltipSideType
  tooltipIcon?: JSX.Element
  toolTipIcon?: boolean;
  ToolTipId?: string

}
export const gridOptions = { rowHeight: 60, rowClass: "custom_css_agGrid" };
export const defaultColDef: any = { sortable: true, resizable: true, filter: true, flex: 1, minWidth: 120 };
export interface modalPropsTypes {
  headerTitle: String;
  modalSize: 'lg' | 'md' | 'sm' | 'sm-x' | 'small';
  btnTitle: string;
  secBtnTitle?: string;
  onClick: (isSecBtn?: boolean) => void;
  onSubmit: (e: React.FormEvent) => void;
  children: JSX.Element;
  fontWeight?: string;
  closeModal: (name?: string) => void;
  name?: string;
  subHeaderTitle?: string;
  className?: string;
  overflow?: boolean
  btnVisible?: boolean
};
export type modalPropsType = Omit<modalPropsTypes, "onSubmit">
export type FormModalPropsType = Omit<modalPropsTypes, "onClick">

export type btnTitleTypeCustomer = 'Project Summary' | 'Proceed' | 'Quick Plant Analysis' | "Site Details"

export const uploadLeadsCsvData = [["First name", "Last name", "Address", "Mobile", "Email",], ["Rajat", "mishra", "Noida one, Noida sec-62, Uttar pradesh", "9852122587", "example@gmail.com"]];
export type userRole = "Consumer" | "";
// export type userRole = "Admin" | "Partner" | "Consumer" | "verifyUserType" |"";
export interface AuthState {
  isAuthenticated: boolean
  user: {
    role: userRole
    hassceen: boolean
  }
}
export type AxioMethodType = "put" | "patch" | "get" | "post";
export interface IGeneration {
  pvNXT: string;
  sam: string;
}

export interface CountryLocationInterface {
  address: Address
  location: Location
}

export interface Address {
  Match_addr: string
  LongLabel: string
  ShortLabel: string
  Addr_type: string
  Type: string
  PlaceName: string
  AddNum: string
  Address: string
  Block: string
  Sector: string
  Neighborhood: string
  District: string
  City: string
  MetroArea: string
  Subregion: string
  Region: string
  RegionAbbr: string
  Territory: string
  Postal: string
  PostalExt: string
  CntryName: string
  CountryCode: string
  X: number
  Y: number
  InputX: number
  InputY: number
}

export interface Location {
  x: number
  y: number
  spatialReference: SpatialReference
}

export interface SpatialReference {
  wkid: number
  latestWkid: number
}


export const isValidName = (input: string): boolean => {
  return /^[a-zA-Z]+$/.test(input);
};

export interface authCheckResTy {
  activestatus: boolean
  emailotp: number
  emailverify: boolean
  issignupcomplete: boolean
  userdetails: user_mstr_modal
}
export interface suportRequestTy {
  userid: string
  fname: string
  lname: string
  subjectid: string
  message: string
  mobile: string
  files?: File | File[];
}

export type gridType = "On Grid" | "Off Grid" | "Hybrid";
export type TActiveTool = "point" | "polyline" | "polygon" | "circle" | "rectangle" | "move" | "transform" | "reshape" | "rectangle-selection" | "lasso-selection" | null
export type informationModalType = "error" | "warning" | "primary" | undefined;

export interface ProfileModalOptionsTy {
  view: boolean
  setting: boolean
  support: boolean
  password: boolean
  address?: boolean
}
export interface ProfileModalOptions extends ProfileModalOptionsTy {
  success: boolean;
  message: string
  supporttrack: boolean;
  proposal: boolean;
}

export interface DashboardModalsTy {
  support: boolean;
  success: boolean;
  message: string;
}


export interface UnitOptions {
  length: string[];
  mass: string[];
  capacity: string[];
  temperature: string[];
  time: string[];
}

export type RadioButtonOption = { label: string; value: string };

export type UnitSettingItem = {
  labelname: string;
  options: RadioButtonOption[];
  value: string;
  name: string;
  id: string
};

export type UnitSettings = {
  Imperial: UnitSettingItem[];
  Metric: UnitSettingItem[];
};

export type UnitSelection = {
  unitsType: "Imperial" | "Metric";
  LengthDistance: string;
  MassWeight: string;
  CapacityVolume: string;
  Temperature: string;
  Time: string;
};

export type CurrencyTy = {
  currency: "US Dollar (USD)" | "India (INR)" | "Saudi Riyal (SAR)"
}


export const SAMAPIGenerationBody = {
  "arr": [
    {
      "intermoduledistance_x": 0.02,
      "intermoduledistance_y": 0.02,
      "pvlayout": "landscape",
      "rowSpacingV": 0.1,
      "rowSpacingH": 0.3,
      "subarray_tilt": 20,
      "subarray_tilt_eq_lat": 0,
      "subarray_rotlim": 45,
      "subarray_azimuth": 20,
      "subarray_nstrings": 26,
      "subarray_modules_per_string": 26,
      "subarray_rear_soiling_loss": 2,
      "subarray_mismatch_loss": 0.02,
      "subarray_dcwiring_loss": 1.5,
      "subarray_electrical_mismatch": 2,
      "total_avialable_plant_area": 3622
    }
  ],
  "inv": {
    "total_mppts": 1,
    "inverter_count": 1,
    "inverter_model": 1,
    "mppt_low_inverter": 880,
    "mppt_hi_inverter": 1300,
    "inv_ds_paco": 350000,
    "inv_ds_eff": 97.6,
    "inv_ds_pnt": 15,
    "inv_ds_pso": 489.047,
    "inv_ds_vdco": 1190,
    "inv_ds_vdcmax": 1300,
    "inverter_temp_load": "3593.0, 3593.0, 3437.0, 3437.0, 3125.0, 0.0"
  },
  "module": {
    "module_conversion_efficiency": 0.211,
    "moduleLength": 1.7,
    "moduleWidth": 1,
    "celltech": 0,
    "vmp": 41.9,
    "imp": 12.91,
    "voc": 49.8,
    "pmp": 540.929,
    "isc": 13.53,
    "bvoc": -0.12699,
    "aisc": 0.0043296,
    "gpmp": -0.331,
    "nser": 72,
    "area": 1.80063,
    "tnoct": 44.5,
    "standoff": 0,
    "mounting": 0,
    "is_bifacial": 1,
    "bifacial_transmission_factor": 0.013,
    "bifaciality": 0.7,
    "bifacial_ground_clearance_height": 1,
    "transient_thermal_model_unit_mass": 11.0919,
    "tranmission_loss": 0
  },
  "loss": {
    "subarray_soiling": 0.02,
    "en_snow_model": 0,
    "dcoptimizer_loss": 0,
    "acwiring_loss": 0.025,
    "auxilary_loss": 0.01,
    "quality_loss": 0.06,
    "lid_loss": 0.02,
    "system_unavailibility_loss": 0.01
  },
  "systemDesign": {
    "system_capacity": 356,
    "use_wf_albedo": 1,
    "use_spatial_albedos": 0,
    "irrad_mode": 0,
    "albedo": 0.2,
    "sky_model": 2,
    "enable_mismatch_vmax_calc": 0,
    "calculate_rack_shading": 0,
    "calculate_bifacial_electrical_mismatch": 1,
    "module_model": 2,
    "module_aspect_ratio": 1.6680202,
    "en_batt": 0,
    "en_benable_subhourly_clippingatt": 0,
    "adjust_constant": 0,
    "adjust_en_timeindex": 0,
    "adjust_en_periods": 0,
    "subarray_monthly_tilt": [
      0
    ],
    "grid_interconnection_limit_kwac": 100000,
    "adjust_timeindex": [
      0
    ],
    "adjust_periods": [
      0,
      0,
      0
    ],
    "mms_length": 4.5
  },
  "timezone": 5.5,
  "loading_in_percent": 20,
  "cable": {
    "ac_initial_temp": 363,
    "cable_initial_resistance_by_length_ac": 0.0059,
    "cable_initial_resistance_by_length_dc": 0.00461,
    "cable_reactance_ac": 0.0000927,
    "dc_initial_temp": 293,
    "length_of_ac_cable": 5,
    "length_of_dc_cable": 5
  }
}

// export const GenerationKey = "annual energy="
export const GenerationKey = "Annual AC energy in Year 1"
export const GenerationPerformance = "Performance ratio in Year 1"

// generation reqbody 


export const GenerationFinance = { "arr": [{ "subarray_nstrings": 2, "subarray_modules_per_string": 8, "subarray_mppt_input": 1, "subarray_tilt": 20, "subarray_azimuth": 180, "subarray_shade_mode": 0, "subarray_slope_tilt": 0, "subarray_slope_azm": 0, "subarray_rear_soiling_loss": 0, "subarray_rack_shading": 4, "subarray_mismatch_loss": 2, "subarray_diodeconn_loss": 0.5, "subarray_dcwiring_loss": 2, "subarray_electrical_mismatch": 0, "subarray_nmodx": 8, "subarray_nmody": 2, "intermoduledistance_y": 0.02, "intermoduledistance_x": 0.02, "rowSpacingH": 0.1, "rowSpacingV": 1.24, "total_avialable_plant_area": 100, "pvlayout": "landscape", "shadingIntervals": [{ "targetString": 0, "shadedModuleCount": 0, "startDate": "2025-11-10T07:07:44.965Z", "endDate": "2025-11-10T07:07:44.965Z", "startHour": 0, "endHour": 0, "shadingFraction": 0, "assumeBypass": true }] }], "inv": { "total_mppts": 1, "inverter_count": 1, "mppt_low_inverter": 100, "mppt_hi_inverter": 800, "inv_ds_paco": 5000, "inv_temp_nominal": 50, "inv_ac_power_derate": 4500, "inv_temp_derate_start": 55, "inv_ac_power_shutdown": 4000, "inv_temp_shutdown": 60, "inv_ds_eff": 97.6, "inv_ds_pnt": 0.55, "inv_ds_pso": 40.41, "inv_ds_vdco": 660, "inv_ds_vdcmax": 800 }, "module": { "vmp": 37.34, "imp": 8.57, "voc": 45.27, "isc": 9.32, "bvoc": -0.1427, "aisc": 0.0000772, "gpmp": -0.331, "nser": 72, "tnoct": 44.9, "is_bifacial": 0, "bifaciality": 0.7, "bifacial_ground_clearance_height": 1, "moduleLength": 1.7, "moduleWidth": 1 }, "loss": { "subarray_soiling": 5, "dcoptimizer_loss": 0, "acwiring_loss": 1, "auxilary_loss": 0.6, "quality_loss": 0.6, "lid_loss": 1.5, "system_unavailibility_loss": 0.1 }, "systemDesign": { "albedo": 0.2, "mms_length": 4.5 }, "cable": { "dc_initial_temp": 293, "ac_initial_temp": 363, "cable_initial_resistance_by_length_dc": 0.00461, "cable_initial_resistance_by_length_ac": 0.0059, "length_of_ac_cable": 5, "length_of_dc_cable": 5 }, "timezone": 5.5 }


export const GenerationFinanceArea = (data: moduleInverterTy, totalarea?: number, StringCount?: number
) => {
  const { module, inverter, stringsInParallel, modulesPerString, inverterCount } = data;

  // --- Module Mapping (direct from new object) ---
  const isBifacial = module?.bifacial ? 1 : 0;
  const bifaciality = isBifacial ? 0.7 : 0;

  const moduleData = {
    vmp: module?.v_mp_ref, // Vmp
    imp: module?.i_mp_ref, // Imp
    voc: module?.v_oc_ref, // Voc
    isc: module.i_sc_ref, // Isc
    // bvoc: module.beta_oc / 1000, // Convert mV/°C → V/°C
    bvoc: module.beta_oc, // Convert mV/°C → V/°C
    aisc: module.alpha_sc, // Convert mA/°C → A/°C
    gpmp: module.gamma_r, // Power temp coeff (%/°C)
    nser: module.n_s, // Cells in series
    tnoct: module.t_noct,
    is_bifacial: isBifacial,
    bifaciality,
    // bifacial_ground_clearance_height: 1, // remove add to arr as mms_height
    moduleLength: module.length,
    moduleWidth: module.width
  };

  // --- Inverter Mapping (direct from new object) ---
  const invData = {
    total_mppts: 1, // Not provided in data
    inverter_count: inverterCount,
    mppt_low_inverter: inverter.mppt_low,
    mppt_hi_inverter: inverter.mppt_high,
    inv_ds_vdcmax: inverter.vdcmax,
    inv_ds_vdco: inverter.vdco,
    inv_ds_paco: inverter.paco,
    inv_ac_power_derate: inverter.paco,
    inv_ds_eff: 97, // assume 97% if not given
    inv_ds_pso: inverter.pso,
    inv_ds_pnt: inverter.pnt,
    inv_ac_power_shutdown: inverter.paco,
    inv_temp_nominal: 50,
    inv_temp_derate_start: 55,
    inv_temp_shutdown: 60
  };

  // --- String Configuration ---
  // const subarray_modules_per_string = string.seriesModules;
  // const subarray_nstrings = string.parallelStrings;
  // const subarray_nstrings = 1;

  // const graphic = globalLayers.sketchLayers?.graphics.filter(e => (e.attributes.name as string).includes('build')) as Collection<Graphic>
  // --- Full Request Body ---
  return {
    arr: [
      {
        subarray_nstrings: stringsInParallel,
        subarray_modules_per_string: modulesPerString,
        subarray_mppt_input: 1,
        subarray_tilt: 20,
        subarray_azimuth: 180,
        subarray_shade_mode: 0,
        subarray_slope_tilt: 0,
        subarray_slope_azm: 0,
        subarray_rear_soiling_loss: 0,
        subarray_rack_shading: 4,
        subarray_mismatch_loss: 2,
        subarray_diodeconn_loss: 0.5,
        subarray_dcwiring_loss: 2,
        subarray_electrical_mismatch: 0,
        subarray_nmodx: 8,
        subarray_nmody: 2,
        intermoduledistance_y: 0.02,
        intermoduledistance_x: 0.02,
        rowSpacingH: 0.1,
        rowSpacingV: 1.24,
        total_avialable_plant_area: totalarea ?? 100,
        pvlayout: "landscape",
        mms_height: 1,
        shadingIntervals: [
          {
            targetString: 0,
            shadedModuleCount: 0,
            startDate: new Date().toISOString(),
            endDate: new Date().toISOString(),
            startHour: 0,
            endHour: 0,
            shadingFraction: 0,
            assumeBypass: true
          }
        ]
      }
    ],
    // inv: invData,
    // module: moduleData,
    loss: {
      subarray_soiling: 5,
      dcoptimizer_loss: 0,
      acwiring_loss: 1,
      auxilary_loss: 0.6,
      quality_loss: 0.6,
      lid_loss: 1.5,
      system_unavailibility_loss: 0.1
    },
    systemDesign: { albedo: 0.2, mms_length: 4.5 },
    cable: {
      dc_initial_temp: 293,
      ac_initial_temp: 363,
      cable_initial_resistance_by_length_dc: 0.00461,
      cable_initial_resistance_by_length_ac: 0.0059,
      length_of_ac_cable: 5,
      length_of_dc_cable: 5
    },
    ring: {
      // geometry: graphic.getItemAt(0).geometry,
      // "mmsData": {
      //   "orientation": "string",
      //   "moduleLength": 0,
      //   "moduleWidth": 0,
      //   "mmsHeight": 0,
      //   "rows": 0,
      //   "columns": 0,
      //   "horizontalSpacing": 0,
      //   "verticalSpacing": 0,
      //   "module_pmp": 0,
      //   "rowSpacingH": 0,
      //   "rowSpacingV": 0,
      //   "tolerance": 0,
      //   "tiltAngle": 0,
      //   "azimuthAngle": 0
      // },
      // "latitude": (graphic.getItemAt(0).geometry as Polygon).centroid.latitude
    },
    timezone: 5.5
  };
};



//  // --- Inverter Mapping ---
//   // --- Compute total DC capacity ---
//   const totalModules =
//     (subarray_nstrings ?? 0) * (modules_per_string ?? 0);
//   const moduleWatts = (moduleData.vmp || 0) * (moduleData.imp || 0);
//   const totalDCkW = (totalModules * moduleWatts) / 1000;

//   // --- Extract inverter nominal power (kW) ---
//   const inverterKW = getVal(inverter?.general, "PNomConv");
//   const targetDCACratio = 1.2;
//   const inverterCount =
//     inverterKW > 0 ? Math.ceil(totalDCkW / (inverterKW * targetDCACratio)) : 1;

//   // --- Inverter data ---
//   const paco = inverterKW * 1000;




// "ring": {
//     "geometry": {
//       "hasZ": true,
//       "rings": [
//         [
//           [
//             0
//           ]
//         ]
//       ]
//     },
//     "mmsData": {
//       "orientation": "string",
//       "moduleLength": 0,
//       "moduleWidth": 0,
//       "mmsHeight": 0,
//       "rows": 0,
//       "columns": 0,
//       "horizontalSpacing": 0,
//       "verticalSpacing": 0,
//       "module_pmp": 0,
//       "rowSpacingH": 0,
//       "rowSpacingV": 0,
//       "tolerance": 0,
//       "tiltAngle": 0,
//       "azimuthAngle": 0
//     },
//     "latitude": 0
//   },